export function matchesExcludeFromIndex(path, excludeList) {
	if (!path || !Array.isArray(excludeList) || excludeList.length === 0) {
		return false;
	}
	return excludeList.some(function (entry) {
		if (typeof entry !== "string" || entry.length === 0) return false;
		if (entry.endsWith("/*")) {
			const prefix = entry.slice(0, -2);
			return path === prefix || path.startsWith(prefix + "/");
		}
		return path === entry;
	});
}
